<template>
    <div>
        <!-- Modal Envio Email -->
        <div class="modal fade" id="envioEmailFaturasModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable" :class="campanha ? 'modal-lg' : 'modal-xl'" role="document">
                <div class="modal-content" v-if="faturas">
                    <div class="modal-header">
                        <h5 class="modal-title">Envio de e-mail</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <az-input v-if="!campanha"
                            label="Mensagem"
                            type="textarea"
                            rows="5"
                            :validade="validate"
                            v-model="mensagem" />

                        <az-input v-if="campanha"
                            label="Selecione o modelo"
                            type="select"
                            :validade="validate"
                            v-model="id_campanha"
                            :optionsList="campanhas"
                            optionsData="id" 
                            optionsDisplay="st_titulo"
                        />

                        <table class="table table-sm mt-3">
                            <thead>
                                <tr>
                                    <th>Operadora</th>
                                    <th>Faturas</th>
                                    <th>Contato</th>
                                    <th>e-mail</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(faturas, id_operadora, idx) in lista_agrupada" :key="idx">
                                    <td>{{ faturas[0].operadora.search }}</td>
                                    <td>{{ faturas.length }}</td>
                                    <td>{{ faturas[0].operadora.st_nome_contato }}</td>
                                    <td>{{ faturas[0].operadora.st_email }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit @click="enviar_email()">Enviar</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';

export default {
    data () { 
        return { 
            faturas: null, 
            mensagem: "", 
            validate: false, 
            campanha: false,
            campanhas: [],
            id_campanha: '',
        }
    },

    components: { 
        AzInput, 
        AzSubmit, 
    },

    computed: { 
        lista_agrupada () { 
            return _.groupBy(
                _.orderBy(this.faturas, 'operadora.search'), 
                'id_operadora'
            );
        }
    },

    methods: { 
        abrir(faturas, campanha = false) {
            this.campanha = campanha;
            this.faturas = _.cloneDeep(faturas);

            if (this.campanha) {
                this.$util.load(this, {
                    service: 'campanhas',
                    func: 'index',
                    parms: {
                        cadastro: false,
                        envio_faturas: true,
                    },
                    loadTo: res => { 
                        if (res && res.length > 0) {
                            this.campanhas = res;
                            $('#envioEmailFaturasModal').modal('show');
                            return;
                        }

                        this.$toast.add({
                            severity: "error",
                            summary: "Atenção",
                            detail: "Configuração para envio de faturas por e-mail não realizada.",
                            life: 3000
                        });
                    }
                });

            } else {

                $('#envioEmailFaturasModal').modal('show');

            }

        },

        enviar_email() { 

            if(this.id_campanha == '') {
                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: "Selecione um modelo.",
                    life: 3000
                });
                return;
            }

            const faturas = this.faturas.map(fatura => fatura.id_fatura);
            
            this.$util.atualizar(this, {
                service: 'campanhas',
                func: 'executar_agora',
                dados: {
                    id: this.id_campanha,
                    faturas: faturas,
                },
                modal: 'envioEmailFaturasModal',
                toast: true,
                msg: 'Fatura(s) enviada(s) com sucesso.',
               
            });
        },
    }
}
</script>
